/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./hdrthumbnail.component";
var styles_HDRThumbnailComponent = [];
var RenderType_HDRThumbnailComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_HDRThumbnailComponent, data: {} });
export { RenderType_HDRThumbnailComponent as RenderType_HDRThumbnailComponent };
export function View_HDRThumbnailComponent_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { container: 0 }), (_l()(), i0.ɵeld(1, 0, [[1, 0], ["container", 1]], null, 1, "div", [["class", "col"]], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n"])), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_HDRThumbnailComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-hdrthumbnail", [], null, null, null, View_HDRThumbnailComponent_0, RenderType_HDRThumbnailComponent)), i0.ɵdid(1, 114688, null, 0, i1.HDRThumbnailComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var HDRThumbnailComponentNgFactory = i0.ɵccf("app-hdrthumbnail", i1.HDRThumbnailComponent, View_HDRThumbnailComponent_Host_0, { imageBase: "imageBase", imageSrc: "imageSrc", thumbHeight: "thumbHeight" }, {}, []);
export { HDRThumbnailComponentNgFactory as HDRThumbnailComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/hdrthumbnail/hdrthumbnail.component.ngfactory.js.pre-build-optimizer.js